import { render, staticRenderFns } from "./ResumeDetails.vue?vue&type=template&id=8316eaf2&"
import script from "./ResumeDetails.vue?vue&type=script&lang=js&"
export * from "./ResumeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports